module.exports = __webpack_public_path__ + "static/img/Connor-Votano.1dca2eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Connor-Votano.jpg
// module id = zLoS
// module chunks = 0